import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import { OtaContext, FleetContext } from "../../context";

import uuidFromUrl from "../../util/strings/uuidFromUrl";
import { SectionGridLayout } from "../../components/Layout";
import OtaFilter from "./OtaFilter";
import OtaVehiclesTable from "./OtaVehiclesTable";

const Ota = () => {
  const { fetchFirmwarePackages, fetchGeofencePackages } = useContext(OtaContext);

  // There are moments when the activeFleet in state gets out of sync with the fleet the user is looking at.
  // This can happen when the user has multiple tabs open and is flipping between fleets,
  // hence the distinction between activeFleet and currFleet as seen below.
  const { fleetId } = useParams();
  const { activeFleet, fleets } = useContext(FleetContext);
  let forceUpdate = false;
  let market = uuidFromUrl(activeFleet.market);

  const currFleet = fleets.find((f) => uuidFromUrl(f.url) === fleetId);
  if (currFleet) {
    forceUpdate = currFleet.market !== activeFleet.market;
    market = uuidFromUrl(forceUpdate ? currFleet.market : activeFleet.market);
  }

  const geofencePackagesParams = { market };

  useEffect(() => {
    fetchFirmwarePackages();
    fetchGeofencePackages(geofencePackagesParams, forceUpdate);
  }, []);

  return (
    <SectionGridLayout>
      <OtaFilter />
      <OtaVehiclesTable />
    </SectionGridLayout>
  );
};

export default Ota;
